import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { drawerFooterStyles } from './styles/drawer-footer.styles';
import type { DrawerFooterPropsInterface } from './types/drawer-footer.types';

/**
 * @since 10.22.0
 */
export const DrawerFooter = forwardRef<HTMLDivElement, DrawerFooterPropsInterface>(
  (props: DrawerFooterPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(drawerFooterStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Drawer.Footer"
        className={cx('c11n', 'c11n_drawer__footer', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DrawerFooter.displayName = 'Drawer.Footer';
